import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CoverageCheckModal from './CoverageCheckModal';
import '../App.css';


const RFC = ({ onShowLoginModal }) => {
  const navigate = useNavigate();
  const [showCoverageModal, setShowCoverageModal] = useState(false);

  const handleRechargeClick = () => {
    const accessToken = localStorage.getItem("accessToken");

    if (accessToken) {
      // Redirect to profile page
      navigate('/profile');
    } else {
      // Show login modal
      onShowLoginModal();
    }
  };

  const handleFibrePlansClick = () => {
    navigate('/fibre');
  };

  return (
    <div className="container-fluid my-4">
      <div className="row" style={{ paddingBottom: '20px' }}>
        <div className="col-12 col-md-4 d-flex flex-column align-items-center justify-content-center mb-4">
          <img
            src="recharge.png"
            alt="Column 1"
            className="img-fluid mb-4"
            style={{ width: '166px', height: '145px' }}
          />
          <button className="btn-custom" onClick={handleRechargeClick}>
            Recharge
          </button>
        </div>

        <div className="col-12 col-md-4 d-flex flex-column align-items-center justify-content-center mb-4">
          <img
            src="fibreplans.png"
            alt="Column 2"
            className="img-fluid mb-4"
            style={{ width: '166px', height: '145px' }}
          />
          <button className="btn-custom" onClick={handleFibrePlansClick}>Fibre Plans</button>
        </div>

        <div className="col-12 col-md-4 d-flex flex-column align-items-center justify-content-center mb-4">
          <img
            src="coverage.png"
            alt="Column 3"
            className="img-fluid mb-4"
            style={{ width: '166px', height: '145px' }}
          />
          <button className="btn-custom" onClick={() => setShowCoverageModal(true)}>Coverage</button>
        </div>
      </div>

      {showCoverageModal && (
        <CoverageCheckModal onClose={() => setShowCoverageModal(false)} />
      )}
    </div>
  );
};

export default RFC;

